export default __webpack_public_path__ + "static/branding-medium-5df91dddce75b8bd31bacbce25f43e6f.otf";